import { useState } from 'react';

import FormError from '@/shared-components/error/components/FormError';
import Text from '@/shared-components/text/components/Text';

import './styles/FixedCharInput.css';

export default function FixedCharInput({ 
  className="",
  value="",
  placeholder="",
  label="",  // persistent label prop
  element, 
  error, 
  onChange, 
  maxChar, 
  small=false, 
  medium=false, 
  large=false, 
  margin=false,
  autoComplete,
  onBlur,
}) {
  const [showLength, setShowLength] = useState(false);

  return (
    <>
      <div className={`fixed-char-input__container ${className} ${margin ? "margin" : ""} ${small ? "small" : ""} ${medium ? "medium" : ""} ${large ? "large" : ""}`}>
        <div className="fixed-char-input__content" id={`${element}_error`}>
          {label && (
            <label htmlFor={element} className="fixed-char-input__label element-non-selectable">
              <Text className="font-size-medium">
                {label}
              </Text>
            </label>
          )}
          <input 
            type="text" 
            spellCheck={false} 
            placeholder={label ? "" : placeholder} 
            className="fixed-char-input__input" 
            name={element} 
            id={element} 
            autoComplete={autoComplete} 
            value={value} 
            onFocus={() => setShowLength(true)} 
            onBlur={(event) => {
              setShowLength(false);
              onBlur?.(event);
            }} 
            onChange={(e) => {
              if(e.target.value.length <= maxChar) {
                onChange(e);
              }
            }}
          />
          {showLength && (
            <Text className="fixed-char-input__chars-left" extraSmall>
              {value.length}/{maxChar}
            </Text>
          )}
        </div>
        <FormError alternativeElement={`${element}_error`} element={element} error={error} errorClassName="fixed-char-input__error-className"/>
      </div>
    </>
  );
}
